//Menu prinicipal
export const HOME_MENU = [
  "camunda-admin",
  "smartAdmin",
  "smartUser",
  "asbpm",
  "camundaHome",
  "smartTenantAdmin",
];
export const GROUP = [
  "camunda-admin",
  "smartAdmin",
  "smartUser",
  "asbpm",
  "camundaHome",
  "smartTenantAdmin",
];
export const ACCESSPROFILE = [
  "camunda-admin",
  "smartAdmin",
  "smartUser",
  "asbpm",
  "camundaHome",
  "smartTenantAdmin",
];
export const DEPLOY_PROCESS_MENU = [
  "camunda-admin",
  "smartAdmin",
  "smartUser",
  "asbpm",
  "camundaDeployProcess",
  "smartTenantAdmin",
];
export const START_PROCESS_MENU = [
  "camunda-admin",
  "smartAdmin",
  "smartUser",
  "asbpm",
  "camundaStartProcess",
  "smartTenantAdmin",
];
export const MY_TASKS_MENU = [
  "camunda-admin",
  "smartAdmin",
  "smartUser",
  "asbpm",
  "camundaViewMyTasks",
  "smartTenantAdmin",
];
export const ALL_TASKS_MENU = [
  "camunda-admin",
  "smartAdmin",
  "smartUser",
  "asbpm",
  "camundaViewAllTasks",
  "smartTenantAdmin",
];
export const ALL_PROCESS_MENU = [
  "camunda-admin",
  "smartAdmin",
  "smartUser",
  "asbpm",
  "camundaViewAllProcess",
  "smartTenantAdmin",
];

//menu de ajuda
export const HELP_MENU = [
  "camunda-admin",
  "smartAdmin",
  "smartUser",
  "asbpm",
  "camundaDeployProcess",
  "smartTenantAdmin",
];

//menu administrativo
//Menus: 'criar usuário' e 'listar usuário'
export const ADMIN_MENU = ["smartAdmin", "smartTenantAdmin"];
export const SYS_ADMIN = ["camunda-admin"];

//Menus: 'editar senha'
export const EDIT_PASSWORD_MENU = [
  "camunda-admin",
  "smartAdmin",
  "smartUser",
  "asbpm",
  "camundaUserProfile",
  "smartTenantAdmin",
];

export const EDIT_MY_PROFILE_TOP_MENU = [
  "camunda-admin",
  "smartAdmin",
  "smartUser",
  "asbpm",
  "camundaUserProfile",
  "smartTenantAdmin",
];

export const ACTIVITY_HISTORY = [
  "camunda-admin",
  "smartAdmin",
  "smartUser",
  "asbpm",
  "camundaViewMyTasks",
  "camundaViewAllTasks",
  "smartTenantAdmin",
];

export const MODELER_PROCESS_MENU = [
  "camunda-admin",
  "smartAdmin",
  "smartUser",
  "asbpm",
  "camundaDeployProcess",
  "smartTenantAdmin",
];

//MENUS SMART REPORT

export const SMART_REPORT_HOME = [
  "smartAdmin",
  "brms-admin",
  "smartReportAdmin",
];
export const DOCUMENTS_MENU = [
  "camunda-admin",
  "smartAdmin",
  "Smartdocsuments",
  "smartTenantAdmin",
];

//MENUS SMART DRIVE

export const SMART_DRIVE_MENU = ["smartAdmin", "SmartDriveAdmin"];
export const SMART_WORKSPACE_MENU = ["smartAdmin", "Smartdocs"];

export const SMART_METADATA_MENU = ["smartAdmin", "Smartdocs"];
export const SMART_FORM_MENU = ["smartAdmin", "SmartForm"];
